import {
    MAX_TRIGGER_ALIGNER,
    MAX_TRIGGER_NOGOS,
    MAX_TRIGGER_WEEKS,
    MIN_TRIGGER_ALIGNER,
    MIN_TRIGGER_NOGOS,
    MIN_TRIGGER_WEEKS
} from '../../services/virtualAppointmentTriggerLimits.ts';

const UNSIGNED_PATTERN = /^\d+$/;

function parseRangedInput(raw: string, min: number, max: number): number | null {
    const trimmed = raw.trim();
    if (!UNSIGNED_PATTERN.test(trimmed)) return null;
    const value = Number(trimmed);
    return value >= min && value <= max ? value : null;
}

export function parseAlignerInput(raw: string): number | null {
    return parseRangedInput(raw, MIN_TRIGGER_ALIGNER, MAX_TRIGGER_ALIGNER);
}

export function parseWeeksInput(raw: string): number | null {
    return parseRangedInput(raw, MIN_TRIGGER_WEEKS, MAX_TRIGGER_WEEKS);
}

export function parseNogosInput(raw: string): number | null {
    return parseRangedInput(raw, MIN_TRIGGER_NOGOS, MAX_TRIGGER_NOGOS);
}
